export function isNullOrUndefinedString(x: any) {
  let result = false
  if (x == null) {
    result = true
  }
  if (x === null) {
    result = true
  }
  if (typeof x === 'undefined') {
    result = true
  }
  return result
}
